import React from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import { useDispatch } from 'react-redux'
import { useActionCallback } from 'hooks'
import { useSelector } from 'hooks/redux'
import {
  setIsDrawerOpening,
  setIsDrawerOpened,
  setIsDrawerClosing,
  setIsDrawerClosed,
  setIsDrawerVisible,
} from 'actions/drawer'

import {
  getIsDrawerVisible,
  getShowDrawerMask,
  getDrawerWidth,
  getDrawerVisibleWidth,
} from 'selectors/drawer'
import { getSelectedId, getIsFullscreen } from 'selectors/navigator'

import Drawer from '../Drawer'
import Render from './Render/Render'

// see drawer props
const ReduxDrawer = (props) => {
  const dispatch = useDispatch()
  const isDrawerVisible = useSelector(getIsDrawerVisible)
  const showDrawerMask = useSelector(getShowDrawerMask)
  const drawerWidth = useSelector(getDrawerWidth)
  const visibleWidth = useSelector(getDrawerVisibleWidth)
  const selectedId = useSelector(getSelectedId)
  const fullscreen = useSelector(getIsFullscreen)

  return (
    <Drawer
      setIsDrawerOpening={useActionCallback(setIsDrawerOpening, dispatch)}
      setIsDrawerOpened={useActionCallback(setIsDrawerOpened, dispatch)}
      setIsDrawerClosing={useActionCallback(setIsDrawerClosing, dispatch)}
      setIsDrawerClosed={useActionCallback(setIsDrawerClosed, dispatch)}
      setIsDrawerVisible={useActionCallback(setIsDrawerVisible, dispatch)}
      isDrawerVisible={isDrawerVisible}
      showDrawerMask={showDrawerMask}
      drawerWidth={drawerWidth}
      visibleWidth={visibleWidth}
      showTab={!isNil(selectedId)}
      fullscreen={fullscreen}
      {...props}
    >
      {isDrawerVisible && <Render />}
    </Drawer>
  )
}

ReduxDrawer.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
}

export default ReduxDrawer
